import { render } from "./OverMij.vue?vue&type=template&id=647c27e2&scoped=true"
import script from "./OverMij.vue?vue&type=script&lang=js"
export * from "./OverMij.vue?vue&type=script&lang=js"

import "./OverMij.vue?vue&type=style&index=0&id=647c27e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-647c27e2"

export default script